import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

type ButtonVariant = "primary" | "secondary" | "success" | "danger" | "link";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, PropsWithChildren {
  variant?: ButtonVariant;
  loading?: boolean;
}

export function Button({ variant = "primary", loading = false, disabled, children, ...props }: ButtonProps) {
  return (
    <button {...props} className={`btn btn-${variant} ${props.className ?? ""}`} disabled={disabled || loading} aria-busy={loading}>
      {loading && <span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />}
      {loading ? "處理中…" : children}
    </button>
  );
}

